const INITIAL_STATE = {
  data: {},
  errors: {},
    
}
const GetIntialServiceAllocation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ALLOCATION_INTIAL_LIST':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ALLOCATION_INTIAL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default GetIntialServiceAllocation;